import React, { useEffect, useState } from "react";
import "./NotasFiscais.css"; // Importa o CSS

const NotasFiscais = () => {
  const [notas, setNotas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [filtroEmpresa, setFiltroEmpresa] = useState("");
  const [filtroDataInicio, setFiltroDataInicio] = useState("");
  const [filtroDataFim, setFiltroDataFim] = useState("");

  // Função para buscar as notas fiscais com filtros
  const fetchNotas = () => {
    setLoading(true);

    let url = `https://welaunchyou.com.br/crm-wly/api/integracoes/listar_notas.php`;

    const params = new URLSearchParams();
    if (filtroEmpresa) params.append("empresa", filtroEmpresa);
    if (filtroDataInicio && filtroDataFim) {
      params.append("data_inicio", filtroDataInicio);
      params.append("data_fim", filtroDataFim);
    }

    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        setNotas(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Erro ao buscar notas fiscais:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchNotas(); // Carregar notas ao iniciar
  }, []);

  // Função para atualizar status manualmente
  const atualizarStatus = () => {
    setUpdating(true);

    fetch("https://welaunchyou.com.br/crm-wly/api/integracoes/atualizar_status_notas.php", {
      method: "POST",
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Atualização de status:", data);
        fetchNotas(); // Recarregar lista de notas após atualização
      })
      .catch((error) => console.error("Erro ao atualizar status:", error))
      .finally(() => setUpdating(false));
  };

  // Função para limpar os filtros
  const limparFiltros = () => {
    setFiltroEmpresa("");
    setFiltroDataInicio("");
    setFiltroDataFim("");
    fetchNotas();
  };

  return (
    <div className="notas-container">
      <h1 style={{ borderBottom: "none" }}>Notas Fiscais</h1>

      {/* Filtros */}
      <div className="filtros">
        <input
          type="text"
          placeholder="Filtrar por Empresa"
          value={filtroEmpresa}
          onChange={(e) => setFiltroEmpresa(e.target.value)}
        />
        <input
          type="date"
          value={filtroDataInicio}
          onChange={(e) => setFiltroDataInicio(e.target.value)}
        />
        <input
          type="date"
          value={filtroDataFim}
          onChange={(e) => setFiltroDataFim(e.target.value)}
        />
        <button onClick={fetchNotas}>🔍 Filtrar</button>
        <button onClick={limparFiltros} className="clear-button">❌ Limpar</button>
      </div>

      {/* Botão de Atualizar Status */}
      <button className="update-button" onClick={atualizarStatus} disabled={updating}>
        {updating ? "Atualizando..." : "🔄 Atualizar Status"}
      </button>

      {loading ? (
        <p className="loading-message">Carregando notas fiscais...</p>
      ) : notas.length === 0 ? (
        <p className="no-notes">Nenhuma nota fiscal encontrada.</p>
      ) : (
        <table className="notas-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Data</th>
              <th>Empresa</th>
              <th>Valor</th>
              <th>Status</th>
              <th>Download</th>
            </tr>
          </thead>
          <tbody>
            {notas.map((nota) => (
              <tr key={nota.id}>
                <td>{nota.id}</td>
                <td>{new Date(nota.created_at).toLocaleDateString()}</td>
                <td>{nota.empresa}</td>
                <td>R$ {parseFloat(nota.valor).toFixed(2)}</td>
                <td>{nota.status}</td>
                <td>
                  {nota.status === "AUTHORIZED" ? (
                    <a
                      href={nota.pdf_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="download-button"
                    >
                      📥 Baixar NF
                    </a>
                  ) : (
                    <span className="waiting-status">Aguardando emissão</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default NotasFiscais;
